import { login, register, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken, setUserInfo } from '@/utils/auth'

const state = {
  token: getToken(),
  loginUser: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_LOGIN_USER: (state, loginUser) => {
    state.loginUser = loginUser
  }
}

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { username, password, code } = userInfo
    return new Promise((resolve, reject) => {
      // 发送登录请求
      login({ username: username.trim(), password: password, code: code }).then(response => {
        const { data } = response
        // 存 Token
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(response) 
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 注册
  register({ commit }, userInfo) {
    const { username, name, phone, email, address, password } = userInfo
    return new Promise((resolve, reject) => {
      register({ 
        username: username.trim(), 
        name: name, 
        phone: phone, 
        email: email, 
        address: address, 
        password: password 
      }).then(response => {
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息 (这是最关键的一步)
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        // 根据你的截图，response.data 包含了 loginUser
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
          return
        }

        const loginUser = data.loginUser || {}
        const roles = loginUser.roles || []
        
        // --- 核心修复：提取 superAdmin ---
        let roles_tmp = []
        if (Array.isArray(roles) && roles.length > 0) {
            roles.forEach(element => {
              // 兼容你的后端返回格式：{ roleName: "superAdmin" }
              if (element && element.roleName) {
                  roles_tmp.push(element.roleName)
              }
              // 兼容简单字符串格式
              else if (typeof element === 'string') {
                  roles_tmp.push(element)
              }
            });
        }
        
        // 如果提取失败，强制给一个 user 角色，防止死循环
        if (roles_tmp.length === 0) {
            console.warn("角色解析为空，自动赋予基础权限");
            roles_tmp.push('user') 
        }

        // 更新数据
        loginUser.avatar = (loginUser.avatar == "" || loginUser.avatar == null) 
          ? require("@/assets/imgs/duck.jpg") 
          : loginUser.avatar
        
        loginUser.roles = roles_tmp // 这里的 roles 现在是 ["superAdmin"] 了

        commit('SET_LOGIN_USER', loginUser)
        setUserInfo(loginUser);
        
        // 这一步决定了 Login.vue 能不能拿到正确的数据
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken()
        commit('SET_TOKEN', '')
        commit('SET_LOGIN_USER', {})
        resolve()
      }).catch(error => {
        removeToken()
        commit('SET_TOKEN', '')
        reject(error)
      })
    })
  },

  // 重置 Token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      commit('SET_TOKEN', '')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
